<div style="height: 100%; overflow: hidden;">
  <div class="search">
    <button *ngIf="hasSiteManagement" class="btn btn-info btn-purchasenewpack" (click)="openUploadModal()">Upload Track</button>
    <button *ngIf="hasSiteManagement" class="btn btn-success btn-purchasenewpack manage-genres" (click)="openGenreEditPanel()">Manage Genres</button>
    <input 
      type='text'
      class='searchtext'
      [(ngModel)]="searchString"
      placeholder='Search Tracks'
      (keyup)='filterByString(true)'>
   
    <ng-select
        [items]="genres"
        multiple="true"
        bindLabel="name"
        selectableGroup="true"
        closeOnSelect="false"
        bindValue="id"
        (change)="genresToFilter = $event; filterByGenres(true)"
        placeholder="Filter by Genre">
    </ng-select>
  </div>

  <ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

  <div id="tracktable">
    <ngx-datatable 
      #tracksTable
      class='material striped datatable'
      [sorts]="[{prop: 'title'}]"
      [rows]='tracksToShow'
      [columnMode]='"force"'
      [headerHeight]='40'
      [footerHeight]='20'
      [scrollbarH]="true"
      [scrollbarV]="true"
      [rowHeight]="40"
      [rowClass]="getTrackRowClass"
      [limit]="10">

      <ngx-datatable-column prop="actions" [sortable]="false" [maxWidth]="180">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
          <span style="cursor: pointer;">
            <i class="fa fa-play invert"></i>
          </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-song-control [track]="row"></app-song-control>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column prop="artist" [sortable]="true" [minWidth]="250" [maxWidth]="250">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
          <span (click)="sort()" style="cursor: pointer;">
            Artist
          </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{row.artist}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column prop="title" [sortable]="true" [minWidth]="250" [maxWidth]="250">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
          <span (click)="sort()" style="cursor: pointer;">
            <i class="flaticon-music invert" style="position: relative; top: -5px;"></i>
          </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{row.title}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column prop="duration" [sortable]="true" [minWidth]="100" [maxWidth]="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
          <span (click)="sort()" style="cursor: pointer;">
            <i class="flaticon-stopwatch invert" style="position: relative; top: -5px;"></i>
          </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{row.duration}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column *ngIf="hasSiteManagement" prop="createdBy" [sortable]="true" [minWidth]="100" [maxWidth]="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
          <span (click)="sort()" style="cursor: pointer;">
            Track ID
          </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{row.trackId}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column *ngIf="hasSiteManagement" prop="createdBy" [sortable]="true" [minWidth]="100" [maxWidth]="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
          <span (click)="sort()" style="cursor: pointer;">
            Created By
          </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{row.createdBy}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column *ngIf="hasSiteManagement" prop="dateCreated" [sortable]="true" [minWidth]="100" [maxWidth]="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
          <span (click)="sort()" style="cursor: pointer;">
            Date Created
          </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{row.dateCreated | date:'MM-dd-yyyy'}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column *ngIf="hasSiteManagement" prop="visible" [sortable]="true" [minWidth]="100" [maxWidth]="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
          <span (click)="sort()" style="cursor: pointer;">
            Visible
          </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <input (change)="toggleVisibility(row.trackId)" [checked]="row.visible" type="checkbox" data-toggle="toggle">
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column *ngIf="hasSiteManagement" prop="duration" [sortable]="true" [minWidth]="100" [maxWidth]="150">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
          <span style="color: rgb(134, 123, 123);">
            Actions
          </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <button (click)="openUploadModal(row)">Edit</button>
          <button (click)="deleteTrack(row)">Delete</button>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column *ngIf="hasSiteManagement" prop="title" [sortable]="true" [minWidth]="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span style="color: white;" >
                Track File
            </span>
        </ng-template>
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template >
             <a *ngIf="!downloadStates[rowIndex + '-download'] || downloadStates[rowIndex + '-download'] === 0" (click)="checkDownloadLink(row, rowIndex)" download href="#">Download</a>
             <span *ngIf="downloadStates[rowIndex + '-download'] === 1 && downloadStates[rowIndex + '-downloadPercent'] === 0">Preparing download...</span>
             <span *ngIf="downloadStates[rowIndex + '-download'] === 1 && downloadStates[rowIndex + '-downloadPercent'] > 0">{{downloadStates[rowIndex + '-downloadPercent']}}%</span>
             <span *ngIf="downloadStates[rowIndex + '-download'] === 3">Complete</span>
             <span *ngIf="downloadStates[rowIndex + '-download'] === 4">Error</span>
             <button (click)="openMetadataModal(row)">Metadata</button>
        </ng-template>
    </ngx-datatable-column>

    </ngx-datatable>
  </div>
</div>